import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#060B19] border-t border-white/8">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src="https://vaanabuildlogictechnologies.com/logo.png"
                alt="Vaana BuildLogic Technologies"
                className="h-9 w-auto"
              />
              <span className="text-white font-semibold text-lg font-['Outfit']">
                
              </span>
            </Link>
            <p className="text-[#94A3B8] text-sm leading-relaxed">
              Empowering businesses with cutting-edge IT solutions, enterprise resource planning, and cloud infrastructure services.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 font-['Outfit']">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About Us" },
                { to: "/services", label: "Services" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-[#94A3B8] text-sm hover:text-[#00E5FF] transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 font-['Outfit']">Services</h4>
            <ul className="space-y-3">
              {[
                "IT Services",
                "ERP Services",
                "Cloud Services",
                "IT Infrastructure",
                "Cyber Security",
                "Security & Surveillance",
              ].map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-[#94A3B8] text-sm hover:text-[#00E5FF] transition-colors duration-300"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 font-['Outfit']">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#00E5FF] mt-0.5 flex-shrink-0" />
                <a href="tel:9953167073" className="text-[#94A3B8] text-sm hover:text-white transition-colors">
                  +91 9953167073
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#00E5FF] mt-0.5 flex-shrink-0" />
                <a href="mailto:info@vaanabuildlogictechnologies.com" className="text-[#94A3B8] text-sm hover:text-white transition-colors break-all">
                  info@vaanabuildlogictechnologies.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#00E5FF] mt-0.5 flex-shrink-0" />
                <span className="text-[#94A3B8] text-sm">
                  Office No. 7 Ground Floor, Indra Nursery, Near Badarpur Metro Station, New Delhi 110044
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#64748B] text-xs">
            &copy; {new Date().getFullYear()} Vaana BuildLogic Technologies. All rights reserved.
          </p>
          <div className="flex gap-6">
            <span className="text-[#64748B] text-xs hover:text-[#94A3B8] cursor-pointer transition-colors">Privacy Policy</span>
            <span className="text-[#64748B] text-xs hover:text-[#94A3B8] cursor-pointer transition-colors">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
